/*
НУ ЧЁ НАРОД ПОГНАЛИ НАХУЙ
┓┏┓┏┓┃
┛┗┛┗┛┃
┓┏┓┏┓┃
┛┗┛┗┛┃ ЕБАНЫЙ РОООООТ!
┓┏┓┏┓┃＼○／
┛┗┛┗┛┃ / /
┓┏┓┏┓┃ノ)
┛┗┛┗┛┃
┓┏┓┏┓┃
┛┗┛┗┛┃
┓┏┓┏┓┃
┛┗┛┗┛┃
┓┏┓┏┓┃
┛┗┛┗┛┃
┓┏┓┏┓┃
┛┗┛┗┛┃
┓┏┓┏┓┃
┛┗┛┗┛┃
┓┏┓┏┓┃
┛┗┛┗┛┃
* */
import myApi from '@/gavnoCode/ApiHandler';
import palantir from "@/gavnoCode/palantir";
import external from '@/gavnoCode/external';
import kostilFiles from "@/store/Form/kostilFiles";
import axios from "axios";

const sendBox = async (data) => {
  palantir.trackAction(200, JSON.stringify(data));
  try {
    const result = await external.run({
      action: 'easyConfirm_set',
      jsonData: {
        GUID: localStorage.getItem('GUIDeasyConf'),
        formType: 'easyBoxAll',
        formData: data
      }
    });

    palantir.trackAction(201, JSON.stringify(result));
  } catch (error) {
    palantir.trackAction(202, JSON.stringify(error));
  }
}
const HandMadeTimeout = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}
/**
 * возвращает форматированный статус проверки заявки
 * @param status {boolean}
 * @param typeRejet {string}
 * @param descrMsg {string}
 * @param data {any}
 * @return {{descrMsg: string, data: null, typeRejet: string, status}}
 */
const formatErrCheckClient = (status, typeRejet = '', descrMsg = '', data = null) => {
  return {
    status: status,
    typeRejet: typeRejet,
    descrMsg: descrMsg,
    data: data
  }
}

const clientFields = () => {
  return [
    {name: 'LAST_NAME', component: 'instInput'},
    {name: 'FIRST_NAME', component: 'instInput'},
    {name: 'SECOND_NAME', component: 'instInput'},
    {name: 'BIRTHDAY', component: 'instInput'},
    {name: 'GENDER', component: 'instSelect'},
    {name: 'PHONE', component: 'instInput'},
    {name: 'EMAIL', component: 'instInput'},
    {name: 'RESIDENTIAL_ADDRESS', component: 'instDadata'},
  ]
}
const passportFields = () => {
  return [
    {name: 'emptyValue', component: 'instSmartId'},
    {name: 'PASSPORT_SERIES', component: 'instInput'},
    {name: 'PASSPORT_NUMBER', component: 'instInput'},
    {name: 'PASSPORT_DEP_CODE', component: 'instInput'},
    {name: 'PASSPORT_DATE', component: 'instInput'},
    // {name: 'BIRTHDAY', component: 'instInput'},
    // {name: 'BIRTHPLACE', component: 'instInput'},
    {name: 'PASSPORT_DEP', component: 'instDadata'},
    // {name: 'RESIDENTIAL_ADDRESS', component: 'instDadata'},
    // {name: 'IS_ADDRESS_COINCIDES', component: 'instCheckBox'},
    {name: 'REGISTRATION_ADDRESS', component: 'instDadata'}
  ]
}
const workInfoFields = () => {
  return [
    {name: 'SOURCE_OF_INCOME', component: 'instSelect'},
    {name: 'WORK_JOB', component: 'instDadata'},
    {name: 'WORK_JOB_PHONE', component: 'instInput'},
    {name: 'EXPER_RADIO', component: 'instSelect'},
    {name: 'WORK_TITLE', component: 'instDadata'},
    {name: 'CONST_INCOME', component: 'instInput'},
    {name: 'AVERAGE_EXPENSES_PER_MONTH', component: 'instInput'},
    {name: 'PURPOSE_OF_THE_LOAN', component: 'instSelect'},
    {name: 'CONTACT', component: 'instInput'},
    {name: 'CONTACT_PHONE', component: 'instInput'},
  ]
}
const workInfoFieldsPens = () => {
  return [
    {name: 'SOURCE_OF_INCOME', component: 'instSelect'},
    {name: 'CONST_INCOME', component: 'instInput'},
    {name: 'AVERAGE_EXPENSES_PER_MONTH', component: 'instInput'},
    {name: 'PURPOSE_OF_THE_LOAN', component: 'instSelect'},
    {name: 'CONTACT', component: 'instInput'},
    {name: 'CONTACT_PHONE', component: 'instInput'},
  ]
}
const smsConfirmFields = () => {
  return [
    {name: 'SmsConfCode', component: 'instSmsInput'},
    {name: 'ASP', component: 'instCheckBox'},
    {name: 'AGREEMENT_KI_REQUEST', component: 'instCheckBox'},
  ];
}
const documentsFields = () => {
  return [
    {name: 'passport1', component: 'instFotoAdd'},
    {name: 'passport2', component: 'instFotoAdd'},
    {name: 'selfImage', component: 'instFotoAdd'},
    {name: 'emptyValue', component: 'instSelectBankInfo'}
  ];
}
const boxConfrim = () => {
  return [
    {name: 'emptyValue', component: 'instBoxConfirm'}
  ]
}

const bindigPayment = () => {
  return [
    {name: 'emptyValue', component: 'instBindigPayment'}
  ]
}
const iuConfrim = () => {
  return [
    {name: 'SmsConfCodeIu', component: 'instSmsInput'},
    {name: 'emptyValue', component: 'instProductInfo'},
    // {name: 'AGREEMENT_IU', component: 'instCheckBox', chekboxTxtComponent: 'instCheckBox_AGREEMENT_IU'},
    // {name: 'AGREEMENT_PDN', component: 'instCheckBox', chekboxTxtComponent: 'instCheckBox_AGREEMENT_PDN'},
    // {name: 'AGREEMENT_ANKETA', component: 'instCheckBox', chekboxTxtComponent: 'instCheckBox_AGREEMENT_ANKETA'},
    // {name: 'AGREEMENT_RECURENT', component: 'instCheckBox'}
    {name: 'AGREEMENT_IU', component: 'instEmptyFormElement', },
    // {name: 'AGREEMENT_PDN', component: 'instEmptyFormElement', }, // ПДН отключён на финальном экране, см. instAgreement_easyconfirm.vue
    {name: 'AGREEMENT_ANKETA', component: 'instEmptyFormElement', },
    {name: 'AGREEMENT_RECURENT', component: 'instEmptyFormElement'},
    {name: 'AGREEMENT_EASY_DRAFT_IU', component: 'instEmptyFormElement'},
    {name: 'emptyValue', component: 'instAgreement_easyconfirm'}
  ]
}
/**
 * проверка корректно заполненых полей
 * @param status - объект текущего статуса поля
 * @param fields - массив проверяемых полей
 * @param dispatch - ссылка на action vuex
 * @return {Promise<unknown>}
 */
const checkFieldsStatus = (status, fields, dispatch) => {
  return new Promise(resolve => {
    let errArray = [];
    for (let i = 0; i < fields.length; i += 1) {
      if (status[fields[i].name].code > 0 && status[fields[i].name].code !== 10) {
        dispatch('errorShow', {
          target: fields[i].name,
          value: true
        });
        errArray.push({
          field: fields[i].name,
          msg: status[fields[i].name].msg
        })
      }
    }
    const result = errArray.length === 0;
    resolve(result);
  });
}
/**
 *
 * @param fieldsValues
 * @return {Promise<unknown>}
 */
const checkExecutionClient = (fieldsValues) => {
  return new Promise((resolve) => {
    myApi.SendRequest({
      action: 'isIssetActiveRequest',
      data: {
        FIRST_NAME: fieldsValues.FIRST_NAME,
        LAST_NAME: fieldsValues.LAST_NAME,
        SECOND_NAME: fieldsValues.SECOND_NAME,
        PHONE: fieldsValues.PHONE
      },
    }).then(res => {
      myApi.singleRequest({action: 'checkfioLog', value: 0, data: res});
      resolve(formatErrCheckClient(true));
    }).catch(res => {
      let ErrorResult = myApi.parseError(res, 'fio isIssetActiveRequest');
      if (ErrorResult.ExecutionErrorCode > 0) {
        myApi.singleRequest({action: 'checkfioLog', value: ErrorResult.ExecutionErrorMessage});
        resolve(formatErrCheckClient(false, 'rejectDraft', 'instRejectTime'));
      } else {
        //случилась некая херня неожиданная, продолжаем принимать заявку
        resolve(formatErrCheckClient(true));
      }
    });
  });
}
const checkExecutionAddress = (fieldsValues) => {
  let result = 0;
  return new Promise((resolve) => {
    myApi.SendRequest({
      action: 'GetAddressTerritory',
      Address: fieldsValues.RESIDENTIAL_ADDRESS,
      RESIDENTIAL_ADDRESS_DADATA: fieldsValues.RESIDENTIAL_ADDRESS_DADATA
    }).then((res) => {
      result = 1;
      resolve(formatErrCheckClient(true, '', '', res));
    }).catch((res) => {
      let ErrorResult = myApi.parseError(res, 'fio adressCheck');
      if (ErrorResult.ExecutionErrorCode > 0) {
        result = -1;
        try {
          if (res.Response.ExecutionError.ExecutionErrorCode > 0) {
            result = res.Response.ExecutionError.ExecutionErrorCode * (-1)
          }
        } catch (e) {
          result = -1;
        }
        resolve(formatErrCheckClient(false, 'rejectDraft', 'instRejectGeo'));
      } else {
        //случилась некая херня неожиданная, продолжаем принимать заявку
        result = 0;
        resolve(formatErrCheckClient(true));
      }
    }).finally(() => {
      myApi.singleRequest({action: 'adressZoneLog', value: result});
    });
  });
}

const saveShortRequest = (fieldsValues) => {
  let sendData = {};
  clientFields().forEach((item) => {
    sendData[item.name] = fieldsValues[item.name];
  });
  sendData['RESIDENTIAL_ADDRESS_DADATA'] = fieldsValues['RESIDENTIAL_ADDRESS_DADATA'];
  myApi.trackUrl(sendData, 'short/addShort.php');
}

const updateShortRequest = (fieldsValues) => {
  let sendData = {};
  passportFields().forEach((item) => {
    sendData[item.name] = fieldsValues[item.name];
  });
  sendData['REGISTRATION_ADDRESS_DADATA'] = fieldsValues['REGISTRATION_ADDRESS_DADATA'];
  myApi.trackUrl(sendData, 'short/addtoshort.php');
}


const best2pay_bindPayment = async (demand) => {
  return new Promise(async (resolve) => {
    console.log(demand)
    await axios({
      method: 'POST',
      url: process.env.VUE_APP_URL_API + 'bindPayment.php',
      data: {
        demand: demand,
        url: window.location.origin + '' +  window.location.pathname + '?r=' + localStorage.getItem('GUIDeasyConf'),
        Session_id: myApi.sessionId(),
        token: myApi.token()
      }
    }).then((res) => {
      if (res?.data?.Error?.Code !== 0) {
        const msg = res?.data?.Error?.Message !== undefined ?
            `code: ${res?.data?.Error?.Code} desc:  ${res?.data?.Error.Message}`
            : 'exeption bindPayment';
        throw new Error(msg);
      }

      if (res?.data?.Data?.value?.payload.toString().length > 0) {
        palantir.trackAction(226, res?.data?.Data?.value?.payload);
        resolve(formatErrCheckClient(true,'','',{href:res?.data?.Data?.value?.payload}));
      } else {
        throw new Error(`undefined payload. ${JSON.stringify(res?.data?.Data)}`);
      }
    }).catch((error)=>{
      palantir.trackAction(227, JSON.stringify(error));
      resolve(formatErrCheckClient(false,'alert', error.message));
    });
  });
}
const formSteps = (formValues = {}) => {
  return [
    {
      sysName: 'Client',
      title: 'Заполните контактную информацию',
      fields: clientFields(),
      buttonTitle: 'продолжить',
      beforeChange: async (fieldValues) => {
        saveShortRequest(fieldValues);
        const resultCheckClients = await checkExecutionClient(fieldValues);
        if (!resultCheckClients.status) {
          return resultCheckClients;
        }
        const resultCheckAdress = await checkExecutionAddress(fieldValues);
        if (!resultCheckAdress.status) {
          return resultCheckAdress;
        }
        if (window.ym) {
          console.log('test ym reachGoal isntClient');
          // eslint-disable-next-line no-undef
          ym(51632228, 'reachGoal', 'isntClient')
        }
        return formatErrCheckClient(true);
      },
      nextStep: {
        final: false,
        name: 'Passport'
      }
    },
    {
      sysName: 'Passport',
      title: 'Заполните паспортные данные',
      fields: passportFields(),
      buttonTitle: 'продолжить',
      nextStep: {
        final: false,
        name: 'WorkInfo'
      },
      beforeChange: async (fieldValues, state, dispatch) => {
        updateShortRequest(fieldValues);
        const parts = fieldValues.BIRTHDAY.split('.');
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10);
        const year = parseInt(parts[2], 10);
        // полных лет на сегодня: минус год, если день рождения в этом году ещё не наступил
        const now = new Date();
        const hadBirthday = now.getMonth() + 1 > month || (now.getMonth() + 1 === month && now.getDate() >= day);
        const fullAge = now.getFullYear() - year - (hadBirthday ? 0 : 1);
        if (fullAge < 18) {
          return formatErrCheckClient(false, 'rejectDraft', 'instRejectTime');
        }
        
        const IS_ADDRESS_COINCIDES_value = (fieldValues.REGISTRATION_ADDRESS === fieldValues.RESIDENTIAL_ADDRESS) ? 'Y' : 'N';
        
        dispatch('saveSendData', {
          target: 'IS_ADDRESS_COINCIDES',
          value: IS_ADDRESS_COINCIDES_value
        });

        const resultCheckAdress = await checkExecutionAddress(fieldValues);
        if (!resultCheckAdress.status) {
          return resultCheckAdress;
        }
        if (window.ym) {
          console.log('test ym reachGoal instPassport');
          // eslint-disable-next-line no-undef
          ym(51632228, 'reachGoal', 'instPassport')
        }
        localStorage.setItem(`passportDone_${window.session_id}`, '1');
        return formatErrCheckClient(true);
      },
    },
    {
      sysName: 'WorkInfo',
      title: 'Заполните данные о месте работы',
      fields: formValues.SOURCE_OF_INCOME === 'пенсия' ? workInfoFieldsPens() : workInfoFields(),
      buttonTitle: 'Получить код',
      nextStep: {
        final: false,
        name: 'smsConfirm'
      },
      beforeChange: async () => {
        if (window.ym) {
          console.log('test ym reachGoal instWorkInfo');
          // eslint-disable-next-line no-undef
          ym(51632228, 'reachGoal', 'instWorkInfo')
        }
        return formatErrCheckClient(true);
      }
    },
    {
      sysName: 'smsConfirm',
      title: 'Подтвердите номер телефона',
      fields: smsConfirmFields(),
      buttonTitle: 'Подтвердить',
      nextStep: {
        final: true,
        name: 'instSaveDemand'
      },
      onMounted: () => {
        if (process.env.NODE_ENV === 'development') {
          alert('в режиме разработки смс не отправилась');
          return false;
        }
        myApi.SendRequest({
          action: 'SMSConfirmationLid',
          PHONE: formValues.PHONE,
        }).then((res) => {
          palantir.trackAction(134, res.ConfirmationGUID);
          localStorage.setItem('ConfirmationGUID', res.ConfirmationGUID);
        }).catch((res) => {
          palantir.trackAction(135, JSON.stringify(res));
        });
      },
      beforeChange: async (fieldValues) => {
        return new Promise(resolve => {
          myApi.SendRequest({
            action: 'SMSConfirmationCodeCheck',
            ConfirmationGUID: localStorage.getItem('ConfirmationGUID'),
            ConfirmationCode: fieldValues.SmsConfCode,
          }).then(res => {
            if (res.CheckResult === true) {
              palantir.trackAction(138, '');
              try {
                myApi.singleRequest({
                  action: 'logSmsConfCode',
                  result: 1
                });
              } catch ($error) {
                if (process.env.NODE_ENV === 'development') {
                  console.log('logSmsConfCode catch')
                }
              }
              
              resolve(formatErrCheckClient(true));
            } else {
              palantir.trackAction(139, '');
              try {
                myApi.singleRequest({
                  action: 'logSmsConfCode',
                  result: -1
                });
              } catch ($error) {
                if (process.env.NODE_ENV === 'development') {
                  console.log('logSmsConfCode catch')
                }
              }
              resolve(formatErrCheckClient(false, 'fieldsError', '', [{
                field: 'SmsConfCode',
                errMsg: 'Некорректный	код'
              }]));
            }
          }).catch((res) => {
            palantir.trackAction(140, JSON.stringify(res));
            try {
              myApi.singleRequest({
                action: 'logSmsConfCode',
                result: -2
              });
            } catch ($error) {
              if (process.env.NODE_ENV === 'development') {
                console.log('logSmsConfCode catch')
              }
            }
            resolve(formatErrCheckClient(false, 'fieldsError', '', [{
              field: 'SmsConfCode',
              errMsg: 'Ошибка сервиса проверки, попробуйте пожалуйста позже'
            }]));
          });
        })
      }
    },
    {
      sysName: 'documents',
      buttonTitle: 'Подтвердить',
      title: 'Прикрепите фото документов для оформления займа',
      fields: documentsFields(),
      nextStep: {
        final: true,
        name: 'instLoaderGetDemandState'
      },
      beforeChange: async (fieldValues) => {
        return new Promise(async (resolve) => {
          if (fieldValues.cdPayment === 'sbp') {
            if (fieldValues.tinkoffA2C_bankSelected.memberId === '') {
              return resolve(formatErrCheckClient(false, 'fieldsError', '', [{
                field: 'cdPayment',
                errMsg: 'Не выбран банк'
              }]));
            }
          }
          if (fieldValues.cdPayment === 'base') {
            if (fieldValues.BankAccount === 0) {
              return resolve(formatErrCheckClient(false, 'fieldsError', '', [{
                field: 'BankAccount',
                errMsg: 'Обязательное поле'
              }]));
            }
          }
          
          if ((fieldValues.cdPayment === 'sbp') && fieldValues.BankAccount === 0) {
          // if ((fieldValues.cdPayment === 'sbp' || fieldValues.cdPayment === 'b2pBindings') && fieldValues.BankAccount === 0) {
            try {
              const result = await myApi.singleRequestUps({
                action: 'saveFileLoan',
                typeRequest: 'loan',
                file: kostilFiles.BankAccount,
                requestGuid: localStorage.getItem('GUIDeasyConf'),
                target: 'BankAccount',
              });
              if (parseInt(result.file_id, 10) > 0) {
                fieldValues.BankAccount = result.file_id;
              }
            } catch ($error) {
              alert('На данный момент мы не можем обработать запрос прикрепления документов. Пожалуйста повторите запрос позже. Код ошибки #f33h4');
              return resolve(formatErrCheckClient(false, 'fieldsError'));
            }
          }
          if (fieldValues.passport3 === 0) {
            try {
              const result = await myApi.singleRequestUps({
                action: 'saveFileLoan',
                typeRequest: 'loan',
                file: kostilFiles.passport3,
                requestGuid: localStorage.getItem('GUIDeasyConf'),
                target: 'passport3',
              });
              if (parseInt(result.file_id, 10) > 0) {
                fieldValues.passport3 = result.file_id;
              }
            } catch ($error) {
              console.log($error);
            }
          }
          let sendData = {
            passport1: fieldValues.passport1,
            passport2: fieldValues.passport2,
            passport3: fieldValues.passport3,
            selfImage: fieldValues.selfImage,
            BankAccount: fieldValues.BankAccount,
            latitude: 0,
            longitude: 0,
            altitude: 0,
            accuracy: 0,
            altitudeAccuracy: 0,
            heading: 0,
            speed: 0,
            requestGuid: localStorage.getItem('GUIDeasyConf'),
            jsonData: {
              tinkoffA2C_bankSelected: fieldValues.tinkoffA2C_bankSelected,
            }
          };
          sendData.action = 'saveImageRequest';
          sendData.externalType = 'zita';
          
          await external.run(sendData).then((res) => {
            palantir.trackAction(194, JSON.stringify(res));
          }).catch((error) => {
            palantir.trackAction(195, JSON.stringify(error));
          });

          if (window.ym) {
            // eslint-disable-next-line no-undef
            ym(51632228, 'reachGoal', 'instRegDoc');
          }
          
          return resolve(formatErrCheckClient(true));
        });
      }
    },
    {
      sysName: 'bindigPayment',
      buttonTitle: 'Подтвердить',
      title: '-',
      fields: bindigPayment(),
      kostil:{
        isViewReady:true
      },
      nextStep: {
        final: true,
        name: 'instLoaderGetDemandState'
      },
      // onMounted: async (state, commit) => {

      // console.log(state.inst_CurrentStepForm)
      //
      // if (navigator.platform !== 'iphone') {
      //   console.log('iphone')
      //   const b2presult = await best2pay_bindPayment(state.demandState.DemandId);
      //   console.log(b2presult)
      //   if (!b2presult.status) {
      //     alert(b2presult.descrMsg);
      //   }
      // } else {
      //   commit('setKostilData',{
      //     isViewReady: true
      //   });
      // }

      // },
      beforeChange: async (fieldValues) => {
        return new Promise(async resolve => {
          if (fieldValues.selectBindPayment === 'b2pBindings') {
            const b2pResult = await best2pay_bindPayment(state.demandState.DemandId);
            // console.log(b2pResult)
            if (b2pResult.status) {
              await external.run({
                action: 'easyConfirm_set',
                jsonData: {
                  GUID: localStorage.getItem('GUIDeasyConf'),
                  formType: 'selectBindPayment',
                  formData: {
                    selectBindPayment: 'b2pBindings',
                    data: fieldValues.tinkoffE2C_cardSelected
                  }
                }
              }).then((res) => {
                palantir.trackAction(226, JSON.stringify(res));
              }).catch((error) => {
                palantir.trackAction(227, JSON.stringify(error));
              });
              window.location.href = b2pResult.data.href;
            } else {
              return  b2pResult;
            }
          } else if (fieldValues.selectBindPayment === 'tkCard') {
            if (fieldValues.tinkoffE2C_cardSelected.cardId !== undefined) {
              await external.run({
                action: 'easyConfirm_set',
                jsonData: {
                  GUID: localStorage.getItem('GUIDeasyConf'),
                  formType: 'selectBindPayment',
                  formData: {
                    selectBindPayment: fieldValues.selectBindPayment,
                    data: fieldValues.tinkoffE2C_cardSelected
                  }
                }
              }).then((res) => {
                palantir.trackAction(224, JSON.stringify(res));
              }).catch((error) => {
                palantir.trackAction(225, JSON.stringify(error));
              });
              return resolve(formatErrCheckClient(true));
            } else {
              return resolve(formatErrCheckClient(false,'alert','Добавьте карту и выберите ее из списка'));
            }
          }

          return resolve(formatErrCheckClient(false));
        });
      }
    },
    {
      sysName: 'anketa',
      buttonTitle: 'Подтвердить',
      title: '',
      nextStep: {
        final: true,
        name: 'instLoaderGetDemandState'
      },
      fields: formValues.SOURCE_OF_INCOME === 'пенсия' ? workInfoFieldsPens() : workInfoFields(),
      beforeChange: async (fieldValues) => {
        return new Promise(async (resolve) => {
          const formData = fieldValues.SOURCE_OF_INCOME === 'пенсия' ? workInfoFieldsPens() : workInfoFields();
          let formDataSend = {}
          for (let item in formData) {
            formDataSend[item.name] = fieldValues[item.name];
          }
          palantir.trackAction(196, 'попытка сохранить поля формы AV');
          await external.run({
            action: 'easyConfirm_set',
            jsonData: {
              GUID: localStorage.getItem('GUIDeasyConf'),
              formType: 'easyAV',
              formData: formDataSend
            }
          }).then((res) => {
            palantir.trackAction(198, JSON.stringify(res));
          }).catch((error) => {
            palantir.trackAction(199, JSON.stringify(error));
          });
          if (window.ym) {
            // eslint-disable-next-line no-undef
            ym(51632228, 'reachGoal', 'instRegQuestionnaire');
          }
          return resolve(formatErrCheckClient(true));
        });
      },
    },
    {
      sysName: 'box',
      buttonTitle: 'Подтвердить',
      title: 'Подтверждение заявки',
      fields: boxConfrim(),
      nextStep: {
        final: true,
        name: 'instLoaderGetDemandState'
      },
      beforeChange: async (fieldValues, state) => {
        return new Promise(async (resolve) => {
          await sendBox(state.boxArr);
          if (window.ym) {
            // eslint-disable-next-line no-undef
            ym(51632228, 'reachGoal', 'instRegBox');
          }
          return resolve(formatErrCheckClient(true));
        });
      }
    },
    {
      sysName: 'iuConfirm',
      buttonTitle: 'Подтвердить',
      title: 'Подтверждение заявки',
      fields: iuConfrim(),
      nextStep: {
        final: true,
        name: 'instLoaderGetDemandState'
      },
      beforeChange: async (fieldValues) => {
        return new Promise(async (resolve) => {
          const sendData = {
            SmsConfCodeIu: fieldValues.SmsConfCodeIu,
            AGREEMENT_IU: fieldValues.AGREEMENT_IU,
            AGREEMENT_PDN: fieldValues.AGREEMENT_PDN,
            AGREEMENT_ANKETA: fieldValues.AGREEMENT_ANKETA,
            AGREEMENT_RECURENT: fieldValues.AGREEMENT_RECURENT,
            boxArr: state.boxArr
          }
          
          await external.run({
            action: 'easyConfirm_set',
            jsonData: {
              GUID: localStorage.getItem('GUIDeasyConf'),
              formType: 'iuConfirm',
              formData: sendData
            }
          }).then((res) => {
            palantir.trackAction(201, JSON.stringify(res));
            if (res.ExecutionError?.ExecutionErrorCode > 0) {
              return resolve(formatErrCheckClient(false, 'fieldsError', '', [{
                field: 'SmsConfCodeIu',
                errMsg: res.ExecutionError?.ExecutionErrorMessage !== undefined ? res.ExecutionError?.ExecutionErrorMessage : 'Некорректный	код'
              }]));
            } else {
              if (window.ym) {
                // eslint-disable-next-line no-undef
                ym(51632228, 'reachGoal', 'instRegIU');
              }
              return resolve(formatErrCheckClient(true));
            }
            
          }).catch((error) => {
            palantir.trackAction(202, JSON.stringify(error));
            console.log(error)
            return resolve(formatErrCheckClient(false));
          });
        });
      }
    },
  ];
}



const state = {
  inst_CurrentStepForm: {},
  inst_formStatus: {
    form: false,
    systemScreen: ''
  },
  demandState: {
    demandState: 0,
    allPhotosAttached: 0,
    allPhotosStatusList: {passport1: 0, passport2: 0, passport3: 0, selfImage: 0, BankAccount: 0},
    ID_ESIA: 0,
    easyAV: 0,
    boxSelected: 0,
    Amount: 0,
    period: 0,
    FixedPay: 0,
    VideoCall: 1,
    CodeSent: 0,
    comment: "",
    bindigPayment: 0,
    DemandId:0,
    Client_Id:0,
  },
  FailsCnt: {
    passport1: 0,
    selfImage: 0,
  },
  boxArr: [],
  clientInfo: {},
};
const getters = {
  stepCounterMax: () => formSteps().length,
  stepCounterCurrent: (state) => {
    const stepForm = formSteps().findIndex((el) => el.sysName === state.inst_CurrentStepForm.sysName);
    return stepForm >= 0 ? stepForm + 1 : 0;
  },
};
const actions = {
  sendEsiaData({rootState}){
    try {
      external.run({
        action: 'easyConfirm_set',
        jsonData:{
          GUID: localStorage.getItem('GUIDeasyConf'),
          formType:'ID_ESIA',
          formData: rootState.Form.sendData.ESIA
        }
      }).finally((result)=>{
        console.log(result);
      });
    }  catch ($event){
      console.log($event);
    }
  },
  instGetBoxArr: async ({commit, state}) => {
    if (state.boxArr.length > 0) return;

    try {
      palantir.trackAction(229,'');
      const resultExternal = await external.run({
        action: 'getBoxArr',
        GUID: localStorage.getItem('GUIDeasyConf')
      });

      if (resultExternal.errorCode > 0 || resultExternal.errorCode !== undefined) {
        palantir.trackAction(231,JSON.stringify(resultExternal));
        throw new Error('ошибка в ответе процедуры');
      }

      const result = Array.isArray(resultExternal.ExecutionResult?.boxArr) ? resultExternal.ExecutionResult : {boxArr: [], clientInfo: {}}
      for (let i = 0; i < result.boxArr.length; i++) {
        try {
          result.boxArr[i].Print_Discription = result.boxArr[i].Print_Discription.split('{*дд.мм.гггг*}').join(result.clientInfo.RejectDate);
          if(result.boxArr[i].Id === 3) {
            //костыль решение для автоматического выбора активной коробки
            result.boxArr[i].isActive = 1;
          }
        } catch ($error) {
          console.log($error);
        }
      }
      commit('instSetBoxArr', result.boxArr);
      commit('instSetClientInfo', result.clientInfo);
      //костыль решение для автоматической фиксации коробки
      console.log('await sendBox');
      await sendBox(result.boxArr);
      console.log('await end sendBox');

    } catch ($error) {
      palantir.trackAction(231,JSON.stringify($error));
    }

  },
  async instSaveFormAV({rootState}) {
    return new Promise((resolve) => {
      let forSendFields = rootState.Form.sendData.SOURCE_OF_INCOME === 'пенсия' ? workInfoFieldsPens() : workInfoFields();
      let forSendObj = {
        GUID: localStorage.getItem('GUIDeasyConf'),
        formType: 'easyAV',
        formData: {}
      };
      forSendFields.forEach((item) => {
        forSendObj.formData[item.name] = rootState.Form.sendData[item.name];
      })
      
      external.run({
        action: 'easyConfirm_set',
        jsonData: forSendObj
      }).then((res) => {
        resolve(false);
        palantir.trackAction(198, JSON.stringify(res));
      }).catch((error) => {
        resolve(true);
        palantir.trackAction(199, JSON.stringify(error));
      });
      
    });
  },
  async instGetDemandState({dispatch, commit}, data) {
    console.log('instStepForm.js instGetDemandState')
    palantir.trackAction(187, '');
    if (data?.iteration === undefined) {
      data = {
        iteration: 0
      }
    }
    if (data.iteration !== undefined && data.iteration > 20) {
      await commit('instSetDealStatus', {demandState: -1});
      return state.demandState;
    }
    try {
      const result = await external.run({
        action: 'get_demandState',
        GUID: localStorage.getItem('GUIDeasyConf'),
      });
      palantir.trackAction(188, JSON.stringify(result));
      if (result?.ExecutionResult?.Amount === 0) {
        data.iteration += 1;
        await HandMadeTimeout(5000);
        return await dispatch('instGetDemandState', data);
      } else {
        // if (process.env.NODE_ENV == 'development') {
        //   await commit('instSetDealStatus', {
        //     "demandState":0,
        //     "allPhotosAttached":1,
        //     "allPhotosStatusList":
        //       {"passport1":0,"passport2":0,"passport3":0,"selfImage":0,"BankAccount":0},
        //     "ID_ESIA":1,
        //     "easyAV":1,
        //     "boxSelected":0,
        //     "CodeSent":0,
        //     "Amount":35000,
        //     "period":10,
        //     "FixedPay":10,
        //     "VideoCall":1,
        //     "comment":""
        //   });
        //
        // } else {
        await commit('instSetDealStatus', result?.ExecutionResult);
        // }
        
        return state.demandState;
      }
      
    } catch ($error) {
      palantir.trackAction(189, JSON.stringify($error));
      await commit('instSetDealStatus', {demandState: -1});
      return state.demandState;
    }
  },
  instSaveDemand({rootState}) {
    return new Promise((resolve) => {
      palantir.trackAction(141, '');
      let preSendData = Object.assign({}, rootState.Form.sendData);
      if (preSendData.CALC_SUMM < rootState.Deal.minBaseProduct.Amount) {
        //magic number, не трогай блиятть
        //потрогал, так как если в калькуляторе не трогали сумму, по умолчанию не присваивалась в this.valueVuex.CALC_SUMM
        preSendData.CALC_SUMM = rootState.Deal.minBaseProduct.Amount;
      }
      if (preSendData.CALC_SUMM > rootState.Deal.maxBaseProduct.Amount) {
        preSendData.CALC_SUMM = rootState.Deal.maxBaseProduct.Amount;
      }
      myApi.singleRequest({
        action: 'SendRequest',
        data: preSendData
      }).then((res) => {
        palantir.trackAction(142, JSON.stringify(res));
        if (res.loadnId !== undefined && parseInt(res.loadnId, 10) > 0) {
          if (window.ym) {
            // eslint-disable-next-line no-undef
            ym(51632228, 'reachGoal', 'allRequest');
            // eslint-disable-next-line no-undef
            ym(51632228, 'reachGoal', 'instLoan');
          }
          resolve(parseInt(res.loadnId, 10));
        } else {
          resolve(0);
        }
      }).catch((res) => {
        palantir.trackAction(143, JSON.stringify(res));
        resolve(0);
      });
    });
  },
  instChekDesignDemand({dispatch}, {demand: demand, iteration: iteration}) {
    return new Promise((resolve) => {
      console.log('!!!!!!!!!!!!!!!!!!!!!!!!! instChekDesignDemand')
      const dealayValue = iteration <= 1 ? 5000 :
        iteration <= 4 ? 10000 : 30000;
      setTimeout(() => {
        myApi.SendRequest({
          action: 'CheckDecisionByID',
          typeRequest: 'loan',
          loandId: demand
        }).then((res) => {
          console.log('guid')
          if (res.OnlineDemandGUID !== undefined) {
            return resolve({
              type: 'registration',
              data: res.OnlineDemandGUID
            });
          } else {
            if (res.onItsWay === 'true') {
              if (res.DealProductType == 'true' || res.DealProductType == true) {
                return resolve({type: 'accepted'});
              } else {
                return resolve({type: 'reject'});
              }
            } else {
              return resolve(dispatch('instChekDesignDemand', {
                demand: demand,
                iteration: iteration + 1
              }));
            }
          }
        }).catch((res) => {
          if (res?.Response?.ExecutionError?.ExecutionErrorCode === 1) {
            return resolve(dispatch('instChekDesignDemand', {
              demand: demand,
              iteration: iteration + 1
            }));
          } else {
            return resolve({type: 'reject'});
          }
        });
      }, dealayValue)
    });
  },
  inst_trySetSystemScreen({commit}, rejectName) {
    const avalaibeleScreen = [
      'instRejectTime',
      'instRejectGeo',
      'instSaveDemand',
      'instLoaderGetDemandState',
      'instApproveDemandDefault',
      'instApproveDemandEasy',
      'instVideoCall'
    ];
    console.log('dispatch inst_trySetSystemScreen ')
    console.log(rejectName)
    if (avalaibeleScreen.includes(rejectName)) {
      commit('inst_setSystemScreen', rejectName);
    } else {
      console.log('что то пошло не так, показывается отказ по умолчанию')
      commit('inst_setSystemScreen', 'instRejectTime');
    }
    palantir.trackInst({scr: rejectName, type: 'open'});
  },
  /**
   * переключатель экрана формы, включит экран по переданному индексу
   * @param commit
   * @param rootState
   * @param nameStart - индекс формы, который нужно отобразить
   */
  inst_initForm({commit, rootState}, nameStart) {
    console.log('######################')
    console.log('inst_initForm')
    console.log(nameStart)
    console.log(state.inst_CurrentStepForm.sysName)
    console.log('######################')
    if (state.inst_CurrentStepForm.sysName === nameStart) {
      return false;
    }
    if (state.inst_CurrentStepForm.sysName !== undefined) {
      palantir.trackInst({scr: state.inst_CurrentStepForm.sysName, type: 'close'});
    }
    const stepForm = formSteps(rootState.Form.sendData).find((el) => el.sysName === nameStart);

    commit('inst_setStepForm', stepForm);
    palantir.trackInst({scr: state.inst_CurrentStepForm.sysName, type: 'open'});

    // console.log(state.inst_CurrentStepForm.onMounted)
    if (state.inst_CurrentStepForm.onMounted !== undefined) {
      state.inst_CurrentStepForm.onMounted(state, commit);
    }


  },
  /**
   * Объект возвращаемого статуса проверки экрана
   * @typedef {Object} ConfirmStep
   * @property {boolean} status - подтверждение экран пройден
   * @property {string} typeRejet - тип отказа
   */
  /**
   * процедура подтверждения обработки данных на экране формы
   * @param rootState
   * @param dispatch
   * @return {ConfirmStep}
   */
  async confirmStep({rootState, dispatch,}) {
    const fieldsChek = await checkFieldsStatus(rootState.Form.workData, state.inst_CurrentStepForm.fields, dispatch);
    //если поля норм, то
    if (fieldsChek) {
      //проверяем есть ли особые проверки шага
      if (state.inst_CurrentStepForm.beforeChange !== undefined) {
        return await state.inst_CurrentStepForm.beforeChange(rootState.Form.sendData, state, dispatch);
      } else {
        return formatErrCheckClient(true, 'nextScreen')
        // dispatch('inst_initForm', state.inst_CurrentStepForm.nextStep.name);
        // return true;
      }
    } else {
      return {status: false, typeRejet: 'fieldsError'};
    }
  },
  // eslint-disable-next-line no-empty-pattern
  async tryUploadFile({rootState, dispatch, commit}, fileObject) {
    return new Promise(async (resolve) => {
      palantir.trackAction(190, `пытка загрузить файл ${fileObject.fileName}`);
      let errorExecution = false;
      switch (fileObject.fileName) {
        case 'passport1':
          if (rootState.Form.sendData.passport3 === 0) {
            const resultP1 = await dispatch('tryUploadFile', {
              fileName: 'passport3',
              fileValue: kostilFiles.passport3
            });
            if (resultP1.execution) {
              await dispatch('saveSendData', {
                target: 'passport3',
                value: resultP1.fileId
              });
            }
          }
          palantir.trackAction(190, `запуск распознавания ${fileObject.fileName}`);
          // eslint-disable-next-line no-case-declarations
          const passportData = await myApi.smartId(fileObject.fileValue);
          palantir.trackAction(190, JSON.stringify({
            msg:'ответ распознавания',
            data: passportData
          }));
          if (!(passportData?.result?.cnt > 0) && state.FailsCnt.passport1 < 1) {
            errorExecution = true;
            commit('FailsCntInc', 'passport1');
            resolve({
              execution: false,
              type: 'ExecutionError',
              msg: passportData?.errorMsg ? passportData?.errorMsg : 'Фото не подходит<br>' +
                  'Паспорт не распознан<br>' +
                  'Убедитесь, что:<br>' +
                  '- Паспорт в центре;<br>' +
                  '- Полностью в кадре;<br>' +
                  '- Без бликов и пальцев;'
            });
            palantir.trackAction(192, {
              msg:'условие блокировки сработало',
              userMsg: passportData?.errorMsg ? passportData?.errorMsg : 'Фото не подходит: на нём не распознан паспорт. *',
              countExternal: state.FailsCnt.passport1
            });
          }
          break;
        // case 'selfImage':
        //   // eslint-disable-next-line no-case-declarations
        //   const selfiData = await exceptionSelfi(fileObject.fileValue);
        //   if (!(selfiData?.result?.totalFaces > 0) && state.FailsCnt.selfImage < 2) {
        //     errorExecution = true;
        //     commit('FailsCntInc', 'selfImage');
        //     resolve({
        //       execution: false,
        //       type: 'ExecutionError',
        //       msg: 'Фото не корректное, попробуйте снова'
        //     });
        //     palantir.trackAction(192, JSON.stringify(selfiData));
        //   }
        //   break;
      }
      
      if (!errorExecution) {
        myApi.singleRequestUps({
          action: 'saveFileLoan',
          typeRequest: 'loan',
          file: fileObject.fileValue,
          requestGuid: localStorage.getItem('GUIDeasyConf'),
          target: fileObject.fileName,
        }).then(res => {
          palantir.trackAction(191, JSON.stringify(res));
          if (res.file_id > 0) {
            resolve({
              execution: true,
              fileId: res.file_id
            });
          } else {
            resolve({
              execution: false,
              type: 'xz',
              msg: 'Временно невозможно обработать файл, пожалуйста попробуйте позже'
            });
          }
        }).catch(error => {
          palantir.trackAction(192, JSON.stringify(error));
          if (error?.Response?.ExecutionError?.ExecutionErrorCode > 0) {
            resolve({
              execution: false,
              type: 'ExecutionError',
              msg: error?.Response?.ExecutionError?.ExecutionErrorMessage
            });
          } else if (error?.ExecutionError?.ExecutionErrorCode !== 0) {
            resolve({
              execution: false,
              type: 'ExecutionError',
              msg: error?.ExecutionError?.ExecutionErrorMessage
            });
          } else {
            resolve({
              execution: false,
              type: 'ExecutionError',
              msg: 'Файл не корректный, допустимы файлы изображения в формате jpg, png'
            });
          }
        });
      }
    });
    
    
  }
};
const mutations = {
  instSetBoxArr: (state, value) => state.boxArr = value,
  instUpdateBoxItem: (state, ObjValue) => state.boxArr[ObjValue.index] = ObjValue.value,
  instSetClientInfo: (state, value) => state.clientInfo = value,
  changeWorkFields: (state, changeIndex) => {
    const whiteList = ['WorkInfo', 'anketa'];
    if (!whiteList.includes(state.inst_CurrentStepForm.sysName)) return false;
    state.inst_CurrentStepForm.fields = changeIndex === 'пенсия' ? workInfoFieldsPens() : workInfoFields();
  },
  /**
   * мутация текущего экрана формы
   * @param state
   * @param stepObj
   */
  inst_setStepForm: (state, stepObj) => {
    state.inst_CurrentStepForm = stepObj;
    state.inst_formStatus.form = true;
  },
  inst_setSystemScreen: (state, screenNameComponent) => {
    state.inst_formStatus.systemScreen = screenNameComponent;
    state.inst_formStatus.form = false;
  },
  FailsCntInc: (state, target) => {
    state.FailsCnt[target] = state.FailsCnt[target] + 1;
  },
  setKostilData: (state, data) => {
    state.inst_CurrentStepForm.kostil = data;
  },
  instSetDealStatus: (state, valueObj) => {
    console.log('commit instSetDealStatus')
    console.log(valueObj)
    const demandState = valueObj.demandState !== undefined && !isNaN(parseInt(valueObj.demandState, 10)) ?
      parseInt(valueObj.demandState, 10) : 0;
    state.demandState.VideoCall = valueObj.VideoCall;
    
    
    state.demandState.demandState = demandState;
    state.demandState.DemandId = valueObj.DemandId !== undefined ? valueObj.DemandId : 0;
    
    state.demandState.Amount = valueObj.Amount !== undefined ? valueObj.Amount : 0;
    state.demandState.FixedPay = valueObj.FixedPay !== undefined ? valueObj.FixedPay : 0;
    state.demandState.period = valueObj.period !== undefined ? valueObj.period : 0;
    
    state.demandState.allPhotosAttached = valueObj.allPhotosAttached;
    try {
      state.demandState.allPhotosStatusList = JSON.parse(valueObj.allPhotosStatusList);
    } catch ($error) {
      console.log($error);
    }

    state.demandState.bindigPayment = valueObj.bindigPayment;
    state.demandState.easyAV = valueObj.easyAV;
    state.demandState.ID_ESIA = valueObj.ID_ESIA;
    state.demandState.boxSelected = valueObj.boxSelected;
    state.demandState.CodeSent = valueObj.CodeSent;


    state.demandState.Client_Id = parseInt(valueObj.Client_Id, 10) > 0 ? parseInt(valueObj.Client_Id, 10) : 0;
    state.demandState.comment = valueObj.comment;
    
    
  }
};
export default {
  state,
  getters,
  actions,
  mutations,
}